import { render, staticRenderFns } from "./ErrorSatisfacao.vue?vue&type=template&id=7c4ebf6e&"
import script from "./ErrorSatisfacao.vue?vue&type=script&lang=js&"
export * from "./ErrorSatisfacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports